import React from 'react'
import { arrayOf, bool, func, shape, string } from 'prop-types'

import { SimpleModal } from '../Modal'
import CollapsibleItem from '../CollapsibleItem'
import { useToggle } from 'hooks/useToggle'

import {
  ModalWrapper,
  DestaqueTitulo,
  ModalTitle,
  TarifaRow,
  TarifaInfo,
  TarifaTitulo,
  TarifaDescricao,
  TarifaValor,
  TextoFinal,
  TabelaRecargaLinha,
  TabelaRecargaCelula,
  TabelaRecargaCabecalho
} from './styles'

// Tabela fixa de taxas de recarga (exibida apenas no plano de Recarga Manual)
const TABELA_RECARGA_MANUAL = [
  { valor: 'R$ 50,00', taxa: 'R$ 9,90', proporcional: '20%' },
  { valor: 'R$ 75,00', taxa: 'R$ 12,90', proporcional: '17%' },
  { valor: 'R$ 100,00', taxa: 'R$ 15,90', proporcional: '16%' },
  { valor: 'R$ 150,00', taxa: 'R$ 21,90', proporcional: '15%' },
  { valor: 'R$ 200,00', taxa: 'R$ 30,90', proporcional: '15%' },
  { valor: 'R$ 250,00', taxa: 'R$ 32,90', proporcional: '13%' },
  { valor: 'R$ 350,00', taxa: 'R$ 34,90', proporcional: '10%' },
  { valor: 'R$ 500,00', taxa: 'R$ 44,90', proporcional: '9%' }
]

const TarifaPlanoModal = ({ tarifas, hideModal, destaque, mostrarTabelaRecarga }) => {
  const [isOpen, toggle] = useToggle(true)
  const [isRecargaOpen, toggleRecarga] = useToggle(true)

  return (
    <SimpleModal hideModal={hideModal} maxWidth={720}>
      <ModalWrapper>
        {destaque && <DestaqueTitulo>{destaque}</DestaqueTitulo>}

        <ModalTitle>Tarifas do plano</ModalTitle>

        <CollapsibleItem active={isOpen} title="Tarifas do plano" onClick={toggle}>
          {tarifas.map(tarifa => (
            <TarifaRow key={tarifa.id}>
              <TarifaInfo>
                <TarifaTitulo>{tarifa.detalhe && tarifa.detalhe.titulo}</TarifaTitulo>
                {tarifa.detalhe && tarifa.detalhe.descricao && (
                  <TarifaDescricao>{tarifa.detalhe.descricao}</TarifaDescricao>
                )}
              </TarifaInfo>
              <TarifaValor>{tarifa.detalhe && tarifa.detalhe.valorTarifaDescricao}</TarifaValor>
            </TarifaRow>
          ))}
        </CollapsibleItem>

        <TextoFinal>
          As cobranças serão feitas com o saldo disponível na sua conta Veloe.
        </TextoFinal>

        {mostrarTabelaRecarga && (
          <CollapsibleItem
            active={isRecargaOpen}
            title="Tarifas de recarga - Plano recarga manual"
            onClick={toggleRecarga}
          >
            <TabelaRecargaLinha>
              <TabelaRecargaCabecalho>Valor</TabelaRecargaCabecalho>
              <TabelaRecargaCabecalho align="center">Taxa</TabelaRecargaCabecalho>
              <TabelaRecargaCabecalho align="right">% proporcional</TabelaRecargaCabecalho>
            </TabelaRecargaLinha>
            {TABELA_RECARGA_MANUAL.map(linha => (
              <TabelaRecargaLinha key={linha.valor}>
                <TabelaRecargaCelula>{linha.valor}</TabelaRecargaCelula>
                <TabelaRecargaCelula align="center">{linha.taxa}</TabelaRecargaCelula>
                <TabelaRecargaCelula align="right">{linha.proporcional}</TabelaRecargaCelula>
              </TabelaRecargaLinha>
            ))}
          </CollapsibleItem>
        )}
      </ModalWrapper>
    </SimpleModal>
  )
}

TarifaPlanoModal.propTypes = {
  hideModal: func,
  destaque: string,
  mostrarTabelaRecarga: bool,
  tarifas: arrayOf(
    shape({
      id: string,
      atividade: string,
      detalhe: shape({
        titulo: string,
        valorTarifaDescricao: string,
        descricao: string
      })
    })
  )
}

TarifaPlanoModal.defaultProps = {
  hideModal: () => {},
  destaque: '',
  mostrarTabelaRecarga: false,
  tarifas: []
}

export default TarifaPlanoModal
